/**
 * Convierte bloques de blog a HTML.
 */

import type { BlogBlock } from './types';

function esc(text: string): string {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/** Permite solo etiquetas b, i, u, strong, em para formato inline. */
function safeInlineHtml(html: string): string {
    const escaped = html
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    return escaped.replace(/&lt;(\/?(?:b|i|u|strong|em))&gt;/gi, '<$1>');
}

function renderBlock(block: BlogBlock): string {
    switch (block.type) {
        case 'heading': {
            const tag = `h${block.level}`;
            return `<${tag}>${safeInlineHtml(block.content)}</${tag}>`;
        }
        case 'paragraph':
            return `<p>${safeInlineHtml(block.content)}</p>`;
        case 'image':
            return `<img src="${esc(block.url)}" alt="${esc(block.alt ?? '')}" />`;
        case 'list': {
            const tag = block.listType === 'ordered' ? 'ol' : 'ul';
            const items = block.items
                .map((item) => `<li>${safeInlineHtml(item)}</li>`)
                .join('');
            return `<${tag}>${items}</${tag}>`;
        }
        case 'blockquote':
            return `<blockquote><p>${safeInlineHtml(block.content)}</p></blockquote>`;
        default:
            return '';
    }
}

export function blocksToHtml(blocks: BlogBlock[]): string {
    const sorted = [...blocks].sort((a, b) => a.order - b.order);
    return sorted.map(renderBlock).join('\n');
}
